var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGoogleplay(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 95,
    height: 34,
    viewBox: "0 0 95 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_3_2374)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3_2374)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M84.7778 26.2885H4.22222C2.41778 26.2885 1 24.9005 1 23.1339V4.20593C1 2.43932 2.41778 1.05127 4.22222 1.05127H84.7778C86.5822 1.05127 88 2.43932 88 4.20593V23.1339C88 24.9005 86.5822 26.2885 84.7778 26.2885Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.7778 1.55602C86.26 1.55602 87.4844 2.75479 87.4844 4.20593V23.1339C87.4844 24.585 86.26 25.7838 84.7778 25.7838H4.22222C2.74 25.7838 1.51556 24.585 1.51556 23.1339V4.20593C1.51556 2.75479 2.74 1.55602 4.22222 1.55602H84.7778ZM84.7778 1.05127H4.22222C2.41778 1.05127 1 2.50241 1 4.20593V23.1339C1 24.9005 2.41778 26.2885 4.22222 26.2885H84.7778C86.5822 26.2885 88 24.9005 88 23.1339V4.20593C88 2.50241 86.5822 1.05127 84.7778 1.05127Z",
    fill: "#A6A6A6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.5464 7.48686C31.5464 7.99161 31.4175 8.43326 31.0952 8.74872C30.7086 9.12728 30.2575 9.31656 29.6775 9.31656C29.0975 9.31656 28.6464 9.12728 28.2597 8.74872C27.873 8.37016 27.6797 7.92851 27.6797 7.36067C27.6797 6.79284 27.873 6.35118 28.2597 5.97262C28.6464 5.59406 29.0975 5.40479 29.6775 5.40479C29.9352 5.40479 30.193 5.46788 30.4508 5.59406C30.7086 5.72025 30.9019 5.84644 31.0308 6.03572L30.7086 6.35118C30.4508 6.03572 30.1286 5.90953 29.6775 5.90953C29.2908 5.90953 28.9041 6.03572 28.6464 6.35118C28.3241 6.60356 28.1952 6.98212 28.1952 7.42377C28.1952 7.86542 28.3241 8.24398 28.6464 8.49635C28.9686 8.74872 29.2908 8.938 29.6775 8.938C30.1286 8.938 30.4508 8.81182 30.773 8.49635C30.9664 8.30707 31.0952 8.0547 31.0952 7.73923H29.6775V7.23449H31.5464V7.48686ZM34.5108 5.90953H32.7708V7.1083H34.3819V7.54995H32.7708V8.74872H34.5108V9.25347H32.2552V5.46788H34.5108V5.90953ZM36.6375 9.25347H36.1219V5.90953H35.0264V5.46788H37.733V5.90953H36.6375V9.25347ZM39.6019 9.25347V5.46788H40.1175V9.25347H39.6019ZM42.3086 9.25347H41.793V5.90953H40.6975V5.46788H43.3397V5.90953H42.2441V9.25347H42.3086ZM48.4308 8.74872C48.0441 9.12728 47.593 9.31656 47.013 9.31656C46.433 9.31656 45.9819 9.12728 45.5952 8.74872C45.2086 8.37016 45.0152 7.92851 45.0152 7.36067C45.0152 6.79284 45.2086 6.35118 45.5952 5.97262C45.9819 5.59406 46.433 5.40479 47.013 5.40479C47.593 5.40479 48.0441 5.59406 48.4308 5.97262C48.8175 6.35118 49.0108 6.79284 49.0108 7.36067C49.0108 7.92851 48.8175 8.37016 48.4308 8.74872ZM45.9819 8.43326C46.2397 8.68563 46.6264 8.87491 47.013 8.87491C47.3997 8.87491 47.7864 8.74872 48.0441 8.43326C48.3019 8.18089 48.4952 7.80233 48.4952 7.36067C48.4952 6.91902 48.3664 6.54046 48.0441 6.28809C47.7864 6.03572 47.3997 5.84644 47.013 5.84644C46.6264 5.84644 46.2397 5.97262 45.9819 6.28809C45.7241 6.54046 45.5308 6.91902 45.5308 7.36067C45.5308 7.80233 45.6597 8.18089 45.9819 8.43326ZM49.7197 9.25347V5.46788H50.2997L52.1686 8.43326V5.46788H52.6841V9.25347H52.1686L50.1708 6.1619V9.25347H49.7197Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 0.19,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.8883 14.8052C43.3416 14.8052 42.1172 15.9409 42.1172 17.5182C42.1172 19.0325 43.3416 20.2312 44.8883 20.2312C46.4349 20.2312 47.6594 19.0956 47.6594 17.5182C47.6594 15.8778 46.4349 14.8052 44.8883 14.8052ZM44.8883 19.0956C44.0505 19.0956 43.3416 18.4015 43.3416 17.4551C43.3416 16.5087 44.0505 15.8147 44.8883 15.8147C45.7261 15.8147 46.4349 16.4456 46.4349 17.4551C46.4349 18.4015 45.7261 19.0956 44.8883 19.0956ZM38.8949 14.8052C37.3483 14.8052 36.1238 15.9409 36.1238 17.5182C36.1238 19.0325 37.3483 20.2312 38.8949 20.2312C40.4416 20.2312 41.6661 19.0956 41.6661 17.5182C41.6661 15.8778 40.4416 14.8052 38.8949 14.8052ZM38.8949 19.0956C38.0572 19.0956 37.3483 18.4015 37.3483 17.4551C37.3483 16.5087 38.0572 15.8147 38.8949 15.8147C39.7327 15.8147 40.4416 16.4456 40.4416 17.4551C40.4416 18.4015 39.7327 19.0956 38.8949 19.0956ZM31.7416 15.6254V16.7611H34.5127C34.4483 17.392 34.1905 17.8968 33.8683 18.2123C33.4816 18.5908 32.8372 19.0325 31.7416 19.0325C30.0016 19.0325 28.7127 17.7075 28.7127 16.004C28.7127 14.3005 30.0661 12.9755 31.7416 12.9755C32.6438 12.9755 33.3527 13.3541 33.8683 13.7957L34.7061 12.9755C33.9972 12.3446 33.0949 11.8398 31.8061 11.8398C29.4861 11.8398 27.4883 13.7326 27.4883 16.004C27.4883 18.2753 29.4861 20.1681 31.8061 20.1681C33.0949 20.1681 33.9972 19.7896 34.7705 18.9694C35.5438 18.2123 35.8016 17.1397 35.8016 16.3195C35.8016 16.0671 35.8016 15.8147 35.7372 15.6254H31.7416ZM60.9994 16.5087C60.7416 15.8778 60.0972 14.8052 58.6794 14.8052C57.2616 14.8052 56.1016 15.8778 56.1016 17.5182C56.1016 19.0325 57.2616 20.2312 58.8083 20.2312C60.0327 20.2312 60.8061 19.4741 61.0638 19.0325L60.1616 18.4015C59.8394 18.8432 59.4527 19.1587 58.8083 19.1587C58.1638 19.1587 57.7772 18.9063 57.4549 18.3384L61.1283 16.8242L60.9994 16.5087ZM57.2616 17.392C57.2616 16.3826 58.0994 15.8147 58.6794 15.8147C59.1305 15.8147 59.5816 16.0671 59.7105 16.3826L57.2616 17.392ZM54.2327 19.9789H55.4572V12.0922H54.2327V19.9789ZM52.2994 15.3731C51.9772 15.0576 51.4616 14.7421 50.8172 14.7421C49.4638 14.7421 48.1749 15.9409 48.1749 17.4551C48.1749 18.9694 49.3994 20.1051 50.8172 20.1051C51.4616 20.1051 51.9772 19.7896 52.2349 19.4741H52.2994V19.8527C52.2994 20.8622 51.7194 21.43 50.8172 21.43C50.1083 21.43 49.5927 20.9253 49.4638 20.4836L48.4327 20.9253C48.7549 21.6193 49.5283 22.5026 50.8816 22.5026C52.2994 22.5026 53.4594 21.6824 53.4594 19.7265V14.9314H52.2994V15.3731ZM50.8816 19.0956C50.0438 19.0956 49.3349 18.4015 49.3349 17.4551C49.3349 16.5087 50.0438 15.8147 50.8816 15.8147C51.7194 15.8147 52.3638 16.5087 52.3638 17.4551C52.3638 18.4015 51.7194 19.0956 50.8816 19.0956ZM66.6061 12.0922H63.7061V19.9789H64.9305V17.0135H66.6061C67.9594 17.0135 69.2483 16.0671 69.2483 14.5529C69.2483 13.0386 67.9594 12.0922 66.6061 12.0922ZM66.6705 15.8778H64.9305V13.1648H66.6705C67.5727 13.1648 68.0883 13.9219 68.0883 14.4898C68.0238 15.1838 67.5083 15.8778 66.6705 15.8778ZM74.0816 14.7421C73.1794 14.7421 72.2772 15.1207 71.9549 15.9409L73.0505 16.3826C73.3083 15.9409 73.6949 15.8147 74.1461 15.8147C74.7905 15.8147 75.3705 16.1933 75.4349 16.8242V16.8873C75.2416 16.7611 74.7261 16.5718 74.2105 16.5718C73.0505 16.5718 71.8905 17.2028 71.8905 18.3384C71.8905 19.411 72.8572 20.1051 73.8883 20.1051C74.7261 20.1051 75.1127 19.7265 75.4349 19.3479H75.4994V19.9789H76.6594V16.9504C76.5305 15.5623 75.4349 14.7421 74.0816 14.7421ZM73.9527 19.0956C73.5661 19.0956 72.9861 18.9063 72.9861 18.4015C72.9861 17.7706 73.6949 17.5813 74.2749 17.5813C74.7905 17.5813 75.0483 17.7075 75.3705 17.8337C75.2416 18.5908 74.5972 19.0956 73.9527 19.0956ZM80.7194 14.9314L79.3661 18.3384H79.3016L77.8838 14.9314H76.5949L78.7216 19.7265L77.4972 22.3764H78.7216L82.0083 14.9314H80.7194ZM69.8927 19.9789H71.1172V12.0922H69.8927V19.9789Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.70309 5.7832C7.50976 5.97248 7.44531 6.28795 7.44531 6.66651V20.6101C7.44531 20.9887 7.5742 21.3041 7.76753 21.4934L7.83198 21.5565L15.8231 13.7329V13.6068L7.70309 5.7832Z",
    fill: "url(#paint0_linear_3_2374)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.4 16.3825L15.7578 13.7956V13.6064L18.4 11.0195L18.4645 11.0826L21.6223 12.8492C22.5245 13.354 22.5245 14.1742 21.6223 14.6789L18.4 16.3825Z",
    fill: "url(#paint1_linear_3_2374)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.4653 16.3196L15.7587 13.6697L7.70312 21.5563C8.02535 21.8718 8.47646 21.8718 9.05646 21.6194L18.4653 16.3196Z",
    fill: "url(#paint2_linear_3_2374)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.4653 11.0198L9.05646 5.78309C8.47646 5.46762 8.02535 5.53071 7.70312 5.84618L15.7587 13.6697L18.4653 11.0198Z",
    fill: "url(#paint3_linear_3_2374)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M18.4009 16.2566L9.05646 21.4302C8.5409 21.7457 8.08979 21.6826 7.76757 21.4302L7.70312 21.4933L7.76757 21.5564C8.08979 21.8088 8.5409 21.8719 9.05646 21.5564L18.4009 16.2566Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.12,
    d: "M7.70309 21.4301C7.50976 21.2409 7.44531 20.9254 7.44531 20.5468V20.6099C7.44531 20.9885 7.5742 21.304 7.76753 21.4932V21.4301H7.70309ZM21.6231 14.4899L18.4009 16.2565L18.4653 16.3196L21.6231 14.553C22.0742 14.3006 22.2675 13.9851 22.2675 13.6697C22.2675 13.9851 22.0098 14.2375 21.6231 14.4899Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.25,
    d: "M9.05642 5.84624L21.6231 12.8496C22.0098 13.102 22.2675 13.3543 22.2675 13.6698C22.2675 13.3543 22.0742 13.0389 21.6231 12.7865L9.05642 5.78315C8.1542 5.2784 7.44531 5.65696 7.44531 6.66645V6.72954C7.44531 5.78315 8.1542 5.34149 9.05642 5.84624Z",
    fill: "white"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_3_2374",
    x: 0,
    y: 0,
    width: 95,
    height: 33.3398,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 3,
    dy: 3
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_3_2374"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_3_2374",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_3_2374",
    x1: 15.0498,
    y1: 6.54663,
    x2: 4.46319,
    y2: 17.3593,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A0FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.007,
    stopColor: "#00A1FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.26,
    stopColor: "#00BEFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.512,
    stopColor: "#00D2FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#00DFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00E3FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_3_2374",
    x1: 22.8042,
    y1: 13.6701,
    x2: 7.21055,
    y2: 13.6701,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.409,
    stopColor: "#FFBD00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.775,
    stopColor: "#FFA500"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF9C00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_3_2374",
    x1: 17.0005,
    y1: 15.1183,
    x2: 2.645,
    y2: 29.7813,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF3A44"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C31162"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_3_2374",
    x1: 5.70341,
    y1: 1.16214,
    x2: 12.1141,
    y2: 7.71016,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#32A071"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.069,
    stopColor: "#2DA771"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.476,
    stopColor: "#15CF74"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.801,
    stopColor: "#06E775"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00F076"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3_2374"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 1,
    width: 87,
    height: 25.3398,
    rx: 4,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoogleplay);
export default __webpack_public_path__ + "static/media/googleplay.54545d7b09bf7de29a729e8b9cd76ef3.svg";
export { ForwardRef as ReactComponent };